export default class ExpenseRegisterModel {
  ExpenseRegisterId: number;
  ExpenseCategoryId: string;
  ExpenseCategoryName: string;
  ExpenseDate: string;
  Amount: number;
  ReferenceNo: string;
  ExpenseFor: string;
  Description: string;
}
